import { use } from "react";
import { DetailPanelContext } from "../detailPanel/DetailPanelContext.ts";
import { EditCardSignaturesDialog } from "./EditCardSignaturesDialog.tsx";
import { SignaturesTooltip } from "./SignaturesTooltip.tsx";

export const SignaturesDisplay = ({
  cardId,
  projectId,
  signatures,
  numberOfSignatures = signatures?.length,
  canEditSignatures = false,
  canRemoveOtherSignatures = false,
}: {
  cardId: string;
  projectId: string;
  signatures?: Array<{ uidNumber: number; name: string }>;
  numberOfSignatures?: number;
  canEditSignatures?: boolean;
  canRemoveOtherSignatures?: boolean;
}) => {
  const { openPanel, closePanel } = use(DetailPanelContext);

  return (
    numberOfSignatures != null && (
      <SignaturesTooltip
        numberOfSignatures={numberOfSignatures}
        signatures={signatures}
        maxSignaturesInTooltip={21}
        onClick={
          !canEditSignatures
            ? undefined
            : () =>
                openPanel(
                  <EditCardSignaturesDialog
                    cardId={cardId}
                    projectId={projectId}
                    canRemoveOtherSignatures={canRemoveOtherSignatures}
                    onClose={closePanel}
                  />,
                )
        }
      />
    )
  );
};
